import React from 'react';
import c from '../w.js';

const IconClose = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5858 12.0001L4.29289 5.70718L5.70711 4.29297L12 10.5859L18.2929 4.29297L19.7071 5.70718L13.4142 12.0001L19.7071 18.293L18.2929 19.7072L12 13.4143L5.70711 19.7072L4.29289 18.293L10.5858 12.0001Z"
      }
    )
  )
);

export { IconClose };
